export default "__VITE_ASSET__Cv7tGAB9__"